export enum DocumentViewableError {
  NotFound = 'NOT_FOUND',
  Processing = 'PROCESSING',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
}
